import tieredPricingRules from "./../../tieredPricingRules.json";
import {__} from '@wordpress/i18n';

export default function TieredPricingDropdown({attributes}) {
    const {quantity, price} = tieredPricingRules[0];
    return (
        <div className="tiered-pricing-dropdown">
            <div className="tiered-pricing-dropdown__select-box" style={{
                borderColor: attributes.activeTierColor,
            }}>
                <div className="tiered-pricing-dropdown-option">
                    <div className="tiered-pricing-dropdown-option__quantity">
                        {quantity} {__('pieces', 'tier-pricing-table')}
                    </div>
                    <div className="tiered-pricing-dropdown-option__pricing">
                        <div className="tiered-pricing-option-price">
                            <div className="tiered-pricing-option-price__discounted">
                                ${price}.00
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tiered-pricing-dropdown__select-box-arrow">
                    <svg height="24" viewBox="0 0 48 48" width="24" xmlns="http://www.w3.org/2000/svg" style={{
                        fill: attributes.activeTierColor,
                    }}>
                        <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z"/>
                        <path d="M0-.75h48v48h-48z" fill="none"/>
                    </svg>
                </div>
            </div>
        </div>
    )
}
